<template>
  <div
      class="order-timeline">
    <div class="order-timeline-heading">
      Return Timeline
    </div>
    <div class="order-timeline-content">
      <div id="order-timeline-statuses">
        <ReturnTimelineStatus
            v-for="(status, idx) in timeline"
            :key="idx"
            v-bind="status" />
      </div>
    </div>
  </div>
</template>

<script>
import ReturnTimelineStatus from "./ReturnTimelineStatus.vue";
import moment from "moment-timezone";
import "../../../../assets/order_timeline_heading.css";

export default {
  name: "ReturnOrderTimeline",
  components: { ReturnTimelineStatus },
  props: {
    returnOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      x: 0,
      timeline: [],
      history: [],
    };
  },
  mounted() {
    const returnOrder =
      this.returnOrder && this.returnOrder.return_order
        ? this.returnOrder.return_order
        : {};
    this.history = Array.isArray(returnOrder.history)
      ? returnOrder.history
      : [];
    this.loadTimeline();
  },
  methods: {
    moment,
    loadTimeline() {
      let timeline = [...this.getTimelineEvent()];
      this.timeline = timeline.sort(
        this.sortByPropertyDesc("dateTime", "statusName")
      );
    },
    getTimelineEvent() {
      let events = [];
      for (let event of this.history) {
        const eventDetails = event || {};
        const eventStatus =
          typeof eventDetails.status === "string" ? eventDetails.status : "";
        let status = "";
        if (eventStatus == "waiting_for_updates") {
          status = "Waiting for Updates";
        } else if (eventStatus == "draft") {
          status = "Draft Created";
        } else {
          status = eventStatus.replace(/_/g, " ");
          let words = status.split(" ");
          status = "";
          for (let word of words) {
            word = word.charAt(0).toUpperCase() + word.slice(1);
            status = status + " " + word;
          }
        }
        let formatted_event = this.createEvent(
          status.trim(),
          eventDetails.description || "",
          eventDetails.created_at
        );
        events.push(formatted_event);
      }
      return events;
    },
    createEvent(status, description, date) {
      let formatted_date = this.$moment
        .tz(date, "GMT")
        .format("MMM DD, YYYY hh:mm A");
      let event = {
        statusName: status,
        subtext: description,
        dateTime: formatted_date,
      };
      return event;
    },
    sortByPropertyDesc(property1, property2) {
      return function (a, b) {
        if (a[property1] > b[property1]) return -1;
        else if (a[property1] < b[property1]) return 1;
        else {
          if (a[property2] > b[property2]) return -1;
          else if (a[property2] < b[property2]) return 1;
        }
        return 0;
      };
    },
    sortByPropertyAsc(property1) {
      return function (a, b) {
        if (a[property1] > b[property1]) return 1;
        else if (a[property1] < b[property1]) return -1;
        return 0;
      };
    },
  },
};
</script>
